import React, { useState, useEffect, useRef } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import toast from 'react-hot-toast';
import validator from 'validator';

// Components
import ChangePasswordModal from '../../Components/Modal/ChangePasswordModal';
import { Image } from '../../Components/formElements/Image';
import config from '../../services/configuration'
import Loader from "../../Components/Loader";
import Layout from '../../Layout/Layout';

//Serivce
import ItemService from "../../services/supplier_appCommonService";

//Redux
import { useSelector, useDispatch } from "react-redux";
import { addUser, getLoginUserData } from '../../redux/feature/userSlice';
import { useNavigate } from 'react-router-dom';
import CustomerConstants from '../../common/CustomerConstants';
const Profile = () => {
  const dispatch = useDispatch();
  let userData = useSelector((state) => state?.user); // User Details from Store
  let navigate=useNavigate()
  const fileInputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [error, setError] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const [formInputs, setFormInputs] = useState({
    "email": "",
    "firstName": "",
    "lastName": "",
    "contactNumber": "",
    "companyName": "",
    "status": "",
    "city": "",
    "country": "",
    "address": "",
    "address2": "",
    "state": "",
    "category": "",
    "cityPostalCode": "",
    "roleId": "",
    "_id": ""
  });

  const [passwordErrors, setPasswordErrors] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const [passwordStrength, setPasswordStrength] = useState({ level: '', color: '', width: '0%' });

  const calculatePasswordStrength = (password) => {
    if (!password || password === "") {
      return { level: '', color: '', width: '0%' };
    }

    let score = 0;
    if (password.length >= 6) score++;
    if (password.length >= 10) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[a-z]/.test(password)) score++;
    if (/[0-9]/.test(password)) score++;
    if (/[^A-Za-z0-9]/.test(password)) score++;

    if (score <= 2) {
      return { level: 'Low', color: '#ff4444', width: '33%' };
    } else if (score <= 4) {
      return { level: 'Medium', color: '#ffaa00', width: '66%' };
    } else {
      return { level: 'High', color: '#00cc00', width: '100%' };
    }
  };

  localStorage.setItem('menu', 'Profile');
  localStorage.setItem('submenu', '-');

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs(formInputs => ({ ...formInputs, [name]: value }));
  };

  const onInputChangePhone = ({ target: { name, value } }) => {
    if (validator.isNumeric(value) || value === "") {
      setFormInputs(formInputs => ({ ...formInputs, [name]: value }));
    }
  };

  // Handle form submission
  const handleSubmit = async () => {

    if (formInputs.firstName === "" || formInputs.lastName === "" || formInputs.contactNumber === "") {
      setErrorMsg('* Fields are mandatory');
      return;
    } else {
      setErrorMsg("")
    }

    const data = {
      "firstName": formInputs?.firstName,
      "lastName": formInputs?.lastName,
      "contactNumber": formInputs?.contactNumber,
      "companyName": formInputs?.companyName,
      "category": formInputs?.category,
      "organisationName": formInputs?.organisationName,
      "status": formInputs?.status,
      "city": formInputs.city,
      "country": formInputs?.country,
      "address": formInputs?.address,
      "address2": formInputs?.address2,
      "state": formInputs?.state,
      "cityPostalCode": formInputs?.cityPostalCode,
      "roleId": formInputs?.roleId,
      "_id": formInputs._id,
      "action": "Profile"
    };
    const toastId = toast.loading('Loading...', {
      position: 'top-right',
    });

    setDisabled(true);
    await ItemService.userUpdate(data).then((item) => {
      // console.log('>> item!', item);
      if (item?.status === 200) {
        toast.success(item?.message || 'User Updated successfully', {
          duration: 2000,
          position: 'top-right',
        });

        // Update response value in Redux Store
        dispatch(addUser(data))

      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: 'top-right',
        });
      }
      setDisabled(false);

    });
    toast.dismiss(toastId);
  };


  const handleSavePassword = async () => {
    const errors = {
      oldPassword: !formInputs.oldPassword || formInputs.oldPassword === "",
      newPassword: !formInputs.newPassword || formInputs.newPassword === "",
      confirmPassword: !formInputs.confirmPassword || formInputs.confirmPassword === "",
    };

    setPasswordErrors(errors);

    if (errors.oldPassword || errors.newPassword || errors.confirmPassword) {
      toast.error('All fields are mandatory', {
        duration: 3000,
        position: 'top-right',
      });
      return;
    }

    if (formInputs.newPassword !== formInputs.confirmPassword) {
      setPasswordErrors({ oldPassword: false, newPassword: false, confirmPassword: true });
      toast.error('New Password and Confirm Password does not match', {
        duration: 3000,
        position: 'top-right',
      });
      return;
    }

    setPasswordErrors({ oldPassword: false, newPassword: false, confirmPassword: false });

    const data = {
     "email":userData?.data?.email,
      "oldPassword": formInputs.oldPassword,
      "newPassword": formInputs.newPassword,
      "confirmPassword": formInputs.confirmPassword,
    };

    const toastId = toast.loading('Loading...', {
      position: 'top-right',
    });
// console.log(">>data",data)
    setDisabled(true);
    await ItemService.changePassword(data).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        toast.success(item?.message || 'User Updated successfully', {
          duration: 2000,
          position: 'top-right',
        });

        // Update response value in Redux Store
        // dispatch(addUser(data))
        navigate(CustomerConstants?.HOME)
      } else {
        setErrorMsg('*' + item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: 'top-right',
        });
      }
      setDisabled(false);
    });
    toast.dismiss(toastId);
  };

  const onPasswordChange = (e) => {
    const { name, value } = e.target;
    setFormInputs(formInputs => ({ ...formInputs, [name]: value }));
    setPasswordErrors(prev => ({ ...prev, [name]: false }));

    if (name === 'newPassword') {
      setPasswordStrength(calculatePasswordStrength(value));
    }
  };

  //Upload Img to Backend
  const uploadImg = async (val) => {
    const { _id, role } = userData?.data;
    const formData = new FormData();
    formData.append("_id", _id);
    formData.append("image", val);
    formData.append("role", role);
    formData.append("action", "Profile");

    const toastId = toast.loading('Loading...', {
      position: 'top-right',
    });

    await ItemService.uploadImg(formData).then((item) => {
      // console.log('>> item!', item);
      if (item?.status === 200) {
        toast.success(item?.message || 'User Updated successfully', {
          duration: 2000,
          position: 'top-right',
        });

        // Update response value after calling the API and Update in Redux Store
        dispatch(getLoginUserData())

      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: 'top-right',
        });
      }

    });
    toast.dismiss(toastId);

    setSelectedImage(userData?.data?.profileImgPath);
  };

  const onUploadFileText = async (data) => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }

  }

  const handleFileSelect = (e) => {
    const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
    const selectedFile = e.target.files && e.target.files[0];
    if (selectedFile) {
      // Check if the selected file is an allowed image format
      if (allowedTypes.includes(selectedFile.type)) {
        // Display the selected image
        const reader = new FileReader();
        reader.onload = (event) => {
          if (event.target) {
            const result = event.target.result;
            if (typeof result === 'string') {
              // console.log(">> result", result);

              uploadImg(e.target.files[0])
              setSelectedImage(result);
              setError(null); // Reset any previous error
            }
          }
        };
        reader.readAsDataURL(selectedFile);
      } else {
        // Display an error message if the selected file format is not allowed
        setError(`Please select a valid image file (${allowedTypes.join(', ')}).`);
        setSelectedImage(null);
      }
    }
  };

  // Populate initial form values from Zustand AuthStore user state
  useEffect(() => {
    if (userData && userData?.data && userData.data.roles?.[0]) {
      const { firstName, lastName, contactNumber, email, _id, companyName, category, organisationName, status, city, address, address2, state, country, cityPostalCode } = userData?.data;
      const roleIdFilter = userData?.data?.roles?.[0]?.roleId || "";
      setFormInputs({

        firstName,
        lastName,
        email,
        contactNumber,
        companyName,
        category,
        organisationName,
        roleId: roleIdFilter,
        status,
        city,
        address,
        address2,
        state,
        country,
        cityPostalCode,
        _id,
      });

      var timestamp = new Date().getTime();
      let res = (userData?.data?.profileImgPath) ? (config.BASE_URL + userData?.data?.profileImgPath + '?t=' + timestamp) : ""
      setSelectedImage(res)
    }
  }, [setFormInputs, userData]);

  return (
    <main className="settings main" id="main">
      <Layout />
      <Row className=''>
        <Col xs={12} md={12} className="rightSide subContent">

          <div className="rightSideInner PageCommonCSS">
            <h2 className='mainTitle'>Your Profile</h2>
            <p className='subText'>This is how your profile looks to other application users.</p>
            <hr />
            <ChangePasswordModal show={modalShow} onHide={() => setModalShow(false)} />
            <section className="section profile">
              <div className="row">
                <div className="col-xl-4">
                  <div className="card">
                    <div className="card-body profile-card pt-4 d-flex flex-column align-items-center">
                      {/* <img src="assets/img/profile-img.jpg" alt="Profile" class="rounded-circle"/> */}
                      {/* <Image srcVal={selectedImage} alt="profile" styleVal={{ maxWidth: '100%' }} classNameVal='profileImageCss' /> */}
                      {
                        <Loader isLoading={!userData?.status} className={"text-center"} />
                      }
                      {selectedImage && userData?.status && (
                        <Image srcVal={selectedImage} alt="profile" styleVal={{ maxWidth: '100%' }} classNameVal='profileImageCss' />
                      )}
                      {!selectedImage && userData?.status && (
                        <i className="bi bi-person-circle iconSize"></i>
                      )}
                      <h2>{userData?.data?.firstName} </h2>
                      <span>
                        <b>{userData?.data?.email}</b>
                      </span>
                      <div className="mb-2">
                        <p className="form-control-plaintext mb-0">
                          <span class="bg-table-status bg-table-success-status m-1 px-2 fs-6 "> {formInputs.status || "N/A"}</span>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
                <div className="col-xl-8">
                  <div className="card ml-4">
                    <div className="card-body pt-3">
                      <ul className="nav nav-tabs nav-tabs-bordered">
                        <li className="nav-item">
                          <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#profile-overview">Overview</button>
                        </li>
                        <li className="nav-item">
                          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#profile-edit">Edit Profile</button>
                        </li>
                        <li className="nav-item">
                          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#profile-change-password">Change Password</button>
                        </li>
                      </ul>
                      <div className="tab-content pt-2">
                        <div className="tab-pane fade show active profile-overview" id="profile-overview">
                          {/* Over view */}
                          <div className="tab-pane fade show active profile-overview" id="profile-overview">
                            <h5 className="card-title">Company</h5>
                            <div className="row">
                              <div className="col-lg-3 col-md-4 label ">Name</div>
                              <div className="col-lg-9 col-md-8">{formInputs.companyName || ""} </div>
                            </div>

                            <div className="row">
                              <div className="col-lg-3 col-md-4 label">Organisation</div>
                              <div className="col-lg-9 col-md-8">{formInputs.organisationName || ""}</div>
                            </div>

                            <div className="row">
                              <div className="col-lg-3 col-md-4 label">Category</div>
                              <div className="col-lg-9 col-md-8">{formInputs.category || ""}</div>
                            </div>

                            <div className="row">
                              <div className="col-lg-3 col-md-4 label">Role</div>
                              <div className="col-lg-9 col-md-8">{formInputs.roleId || ""}</div>
                            </div>
                          </div>
                          <h5 className="card-title">Profile</h5>
                          <div className="row">
                            <div className="col-lg-3 col-md-4 label">First Name</div>
                            <div className="col-lg-9 col-md-8">{formInputs.firstName || ""}</div>
                          </div>
                          <div className="row">
                            <div className="col-lg-3 col-md-4 label">Last Name</div>
                            <div className="col-lg-9 col-md-8">{formInputs.lastName || ""}</div>
                          </div>
                          <div className="row">
                            <div className="col-lg-3 col-md-4 label">Email Id</div>
                            <div className="col-lg-9 col-md-8">{formInputs.email || ""}</div>
                          </div>
                          <div className="row">
                            <div className="col-lg-3 col-md-4 label">Contact Number</div>
                            <div className="col-lg-9 col-md-8">{formInputs.contactNumber || ""}</div>
                          </div>
                          <h5 className="card-title">Address</h5>
                          <div className="row">
                            <div className="col-lg-3 col-md-4 label">Address 1</div>
                            <div className="col-lg-9 col-md-8">{formInputs.address || ""}</div>
                          </div>
                          <div className="row">
                            <div className="col-lg-3 col-md-4 label">Address 2</div>
                            <div class="col-lg-9 col-md-8">{formInputs.address2 || ""}</div>
                          </div>
                          <div className="row">
                            <div className="col-lg-3 col-md-4 label">City</div>
                            <div className="col-lg-9 col-md-8">{formInputs.city || ""}</div>
                          </div>
                          <div className="row">
                            <div className="col-lg-3 col-md-4 label">State</div>
                            <div className="col-lg-9 col-md-8">{formInputs.State || ""}</div>
                          </div>
                          <div className="row">
                            <div className="col-lg-3 col-md-4 label">Country</div>
                            <div className="col-lg-9 col-md-8">{formInputs.Country || ""}</div>
                          </div>
                          <div className="row">
                            <div className="col-lg-3 col-md-4 label">City PostalCode</div>
                            <div className="col-lg-9 col-md-8">{formInputs.cityPostalCode || ""}</div>
                          </div>
                        </div>
                        <div className="tab-pane fade profile-edit pt-3" id="profile-edit">
                          <form>
                            <div className="row mb-3">
                              <label for="profileImage" className="col-md-4 col-lg-3 col-form-label">Profile Image</label>
                              <div className="col-md-8 col-lg-9">
                                {
                                  <Loader isLoading={!userData?.status} className={"text-center"} />
                                }
                                {selectedImage && userData?.status && (
                                  <Image srcVal={selectedImage} alt="profile" styleVal={{ maxWidth: '100%' }} classNameVal='profileImageCss' />
                                )}
                                {!selectedImage && userData?.status && (
                                  <i className="bi bi-person-circle iconSize" onClick={onUploadFileText}></i>
                                )}
                                {error && <div className="error-message">{error}</div>}
                                <p onClick={onUploadFileText} className='uploadPhoto' >Click here to upload the Image</p>
                                {/* Hidden file input */}
                                <input
                                  type="file"
                                  ref={fileInputRef}
                                  styleVal={{ display: 'none' }}
                                  onChange={handleFileSelect}
                                />
                              </div>
                            </div>
                            <h5 className="card-title" style={{ color: '#012970' }}>Company</h5>
                            <div className="row mb-3">
                              <label for="Company" className="col-md-4 col-lg-3 col-form-label">Name</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="companyName" type="text" className="form-control" id="companyName" value={formInputs.companyName || ""} onChange={onInputChange} />
                              </div>
                            </div>

                            <div className="row mb-3">
                              <label for="Organisation" className="col-md-4 col-lg-3 col-form-label">Organisation</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="organisationName" type="text" className="form-control" id="organisationName" value={formInputs.organisationName || ""} onChange={onInputChange} disabled={true} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="category" className="col-md-4 col-lg-3 col-form-label">Category</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="category" type="text" className="form-control" id="category" value={formInputs.category || ""} onChange={onInputChange} disabled={true} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="roleId" className="col-md-4 col-lg-3 col-form-label">Role</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="roleId" type="text" className="form-control" id="roleId" value={formInputs.roleId || ""} onChange={onInputChange} disabled={true} />
                              </div>
                            </div>

                            <h5 className="card-title" style={{ color: '#012970' }}>Profile</h5>
                            <div className="row mb-3">
                              <label for="firstName" className="col-md-4 col-lg-3 col-form-label">First Name</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="firstName" type="text" className="form-control" id="firstName" value={formInputs.firstName || ""} onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="lastName" className="col-md-4 col-lg-3 col-form-label">Last Name</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="lastName" type="text" className="form-control" id="lastName" value={formInputs.lastName || ""} onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="email" className="col-md-4 col-lg-3 col-form-label">Email Id</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="email" type="text" className="form-control" id="email" value={formInputs.email || ""} onChange={onInputChange} disabled={true} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="contactNumber" className="col-md-4 col-lg-3 col-form-label">Contact Number</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="contactNumber" type="text" className="form-control" id="contactNumber" value={formInputs.contactNumber || ""} onChange={onInputChangePhone} />
                              </div>
                            </div>

                            <h5 className="card-title" style={{ color: '#012970' }}>Address</h5>
                            <div className="row mb-3">
                              <label for="address" className="col-md-4 col-lg-3 col-form-label">Address 1</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="address" type="text" className="form-control" id="address" value={formInputs.address || ""} onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="address2" className="col-md-4 col-lg-3 col-form-label">Address 2</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="address2" type="text" className="form-control" id="address2" value={formInputs.address2 || ""} onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="city" className="col-md-4 col-lg-3 col-form-label">City</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="city" type="text" className="form-control" id="city" value={formInputs.city || ""} onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="state" className="col-md-4 col-lg-3 col-form-label">State</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="state" type="text" className="form-control" id="state" value={formInputs.city || ""} onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="country" className="col-md-4 col-lg-3 col-form-label">Country</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="country" type="text" className="form-control" id="country" value={formInputs.country || ""} onChange={onInputChange} />
                              </div>
                            </div>
                            <div className="text-center">
                              <button type="button" className="btn btn-primary" onClick={handleSubmit}>Save Changes</button>
                            </div>
                            <Col xs={12} md={12} lg={12} className='commLeftRightPadding'>
                              <p className='errorMsg'> {errorMsg} </p>
                            </Col>
                          </form>
                        </div>
                        <div className="tab-pane fade pt-3" id="profile-change-password">
                          <form>
                            <div className="row mb-3">
                              <label for="currentPassword" className="col-md-4 col-lg-3 col-form-label fw-bold" style={{ color: 'rgba(1, 41, 112, 0.6)' }}>Old Password</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="oldPassword" type="password" className="form-control" id="oldPassword" value={formInputs.oldPassword || ""}
                                  onChange={onPasswordChange}
                                  style={passwordErrors.oldPassword ? { border: '1px solid red' } : {}} />
                              </div>
                            </div>

                            <div className="row mb-3">
                              <label for="newPassword" className="col-md-4 col-lg-3 col-form-label fw-bold" style={{ color: 'rgba(1, 41, 112, 0.6)' }}>New Password</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="newPassword" type="text" className="form-control" id="newPass" value={formInputs.newPassword || ""}
                                  onChange={onPasswordChange}
                                  style={passwordErrors.newPassword ? { border: '1px solid red' } : {}} />
                                {passwordStrength.level && (
                                  <div style={{ marginTop: '8px' }}>
                                    <div style={{
                                      height: '6px',
                                      backgroundColor: '#e0e0e0',
                                      borderRadius: '3px',
                                      overflow: 'hidden'
                                    }}>
                                      <div style={{
                                        height: '100%',
                                        width: passwordStrength.width,
                                        backgroundColor: passwordStrength.color,
                                        borderRadius: '3px',
                                        transition: 'width 0.3s ease, background-color 0.3s ease'
                                      }}></div>
                                    </div>
                                    <small style={{ color: passwordStrength.color, fontWeight: 'bold', transition: 'color 0.3s ease' }}>
                                      {passwordStrength.level}
                                    </small>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="row mb-3">
                              <label for="confirmPassword" className="col-md-4 col-lg-3 col-form-label fw-bold" style={{ color: 'rgba(1, 41, 112, 0.6)' }}>Re-enter New Password</label>
                              <div className="col-md-8 col-lg-9">
                                <input name="confirmPassword" type="password" className="form-control" id="confirmPassword" value={formInputs.confirmPassword || ""}
                                  onChange={onPasswordChange}
                                  style={passwordErrors.confirmPassword ? { border: '1px solid red' } : {}} />
                              </div>
                            </div>

                            <div className="text-center">
                              <button type="button" className="btn btn-primary" onClick={handleSavePassword} disabled={disabled}>Change Password</button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default Profile;
